import MiniProgramSvg from '@/assets/icons/mini-program.svg'
import { getMiniappScheme } from '@/lib/api/weixinAppApi'
import PlatformDetection from '@/lib/utils/platformDetection'
import { useCallback, useState } from 'react'
import { ActivityIndicator, Platform, Pressable, StyleSheet, View } from 'react-native'
import { Text } from './ui/text'

const platform =
  Platform.OS === 'web' && typeof navigator !== 'undefined' ? new PlatformDetection(navigator.userAgent) : null

const shouldShow = platform ? platform.isWeixinBrowser() && !platform.isMiniProgram() : false

export default function OpenInMiniProgram() {
  const [loading, setLoading] = useState(false)

  const handlePress = useCallback(async () => {
    if (loading) return
    setLoading(true)
    try {
      const res = await getMiniappScheme()
      if (res.success && res.data?.url) {
        window.location.href = res.data.url
      }
    } finally {
      setLoading(false)
    }
  }, [loading])

  if (!shouldShow) return null

  return (
    <View style={styles.container} pointerEvents="box-none">
      <Pressable style={styles.toast} onPress={handlePress}>
        {loading ? <ActivityIndicator size={18} color="#fff" style={styles.spinner} /> : <MiniProgramIcon />}
        <Text style={styles.text}>在小程序中打开</Text>
      </Pressable>
    </View>
  )
}

function MiniProgramIcon() {
  return (
    <View style={styles.iconContainer}>
      <MiniProgramSvg width={18} height={18} color="#fff" />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 124,
    left: 0,
    right: 0,
    alignItems: 'center',
    zIndex: 999,
  },
  toast: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 5,
  },
  iconContainer: {
    marginRight: 6,
  },
  text: {
    color: '#fff',
    fontSize: 13,
  },
  spinner: {
    marginRight: 6,
  },
})
